module.exports = __webpack_public_path__ + "img/5.506df756.gif";